import type { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { useModalConfirm } from "@ryde/redux";
import {
  ConfirmResult,
  formatHHmmTime,
  TimeZoneEnum,
  useFormats,
} from "@ryde/shared";

import { ColorIconButton } from "../../../controls";
import type { ITimeListItemForm } from "./time-list-item.models";

export const TimeListItemDisplay: FC<ITimeListItemForm> = ({
  removeHandler,
  index,
  onEdit,
  value,
  disabledEdit,
  disabledRemove,
}) => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const { timeFormat } = useFormats();
  const message = t(`general.ITEM_ARCHIVE_MESSAGE`);

  const onArchiveClickEvent = useEvent(async (): Promise<void> => {
    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message,
    });

    if (confirmationResult === ConfirmResult.OK) {
      removeHandler?.(index || 0);
    }
  });

  return (
    <div className="time-list-item display-mode">
      <div className="time-list-item__data">
        {value?.time && (
          <div className="time-list-item__data--row">
            <label>{t("produceButton.formLabel.recurring.produceAt")}</label>
            <div className="time-list-cell">
              {formatHHmmTime(value.time, timeFormat, TimeZoneEnum.UTC)}
            </div>
          </div>
        )}
      </div>
      <div className="time-list-item__buttons">
        {!disabledEdit && (
          <ColorIconButton
            iconType="EDIT"
            edge="end"
            aria-label="edit"
            className="edit-button"
            onClick={() => {
              onEdit?.();
            }}
          />
        )}

        {!disabledRemove && (
          <ColorIconButton
            iconType="DELETE"
            edge="end"
            aria-label="delete"
            onClick={() => onArchiveClickEvent()}
          />
        )}
      </div>
    </div>
  );
};
